import { ApiClient } from '@webapp/core/services/ApiClient'
import { ExpenseRepository } from './ExpenseRepository'

export const expenseRepository = new ExpenseRepository({
  httpClient: ApiClient,
})

export { ExpenseRepository } from './ExpenseRepository'
export type {
  ApprovableCounts,
  ListApprovableExpenseSummaryParams,
  ExpenseItemUpdatePayload,
} from './ExpenseRepository'
